import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as biometricsActions from '@store/biometrics/biometrics.actions';
import * as biometricsSelectors from '@store/biometrics/biometrics.selectors';
import { CameraPermissionService } from '@app/domain/services/biometrics/camera-permission.service';
import { IKeynuaWidgetResponse } from '@app/core/models/biometrics.model';

@Injectable({ providedIn: 'root' })
export class BiometricsFacade {
  public step$: Observable<number>;
  public isLoading$: Observable<boolean>;
  public keynuaWidgetResponse$: Observable<IKeynuaWidgetResponse>;
  public isBiometrics$: Observable<boolean>;

  constructor(private _store: Store, private _cameraPermissionService: CameraPermissionService) {
    this.step$ = this._store.select(biometricsSelectors.selectBiometricsStep);
    this.isLoading$ = this._store.select(biometricsSelectors.selectBiometricsIsLoading);
    this.keynuaWidgetResponse$ = this._store.select(biometricsSelectors.selectKeynuaWidgetResponse);
    this.isBiometrics$ = this._store.select(biometricsSelectors.selectIsBiometricsFlag);
  }

  public checkCameraPermission() {
    return this._cameraPermissionService.checkCameraPermission();
  }

  public askForCameraPermission() {
    return this._cameraPermissionService.askForCameraPermission();
  }

  public setBiometricsStep(step: number) {
    this._store.dispatch(biometricsActions.setBiometricsStep({ step }));
  }

  public getKeynuaWidgetToken() {
    this._store.dispatch(biometricsActions.getKeynuaWidgetToken());
  }

  public getKeynuaWidgetStatus() {
    this._store.dispatch(biometricsActions.getKeynuaWidgetStatus());
  }

  public successGetKeynuaWidgetStatus(keynuaWidgetResponse: IKeynuaWidgetResponse) {
    this._store.dispatch(biometricsActions.successGetKeynuaWidgetStatus({ keynuaWidgetResponse }));
  }

  public resetKeynuaWidgetResponse() {
    this._store.dispatch(biometricsActions.resetKeynuaWidgetResponse());
  }

  public setIsBiometricsFlag(isBiometrics: boolean) {
    this._store.dispatch(biometricsActions.setIsBiometricsFlag({ isBiometrics }));
  }
}
